module.exports = __webpack_public_path__ + "img/Mask group.590d2bf2.png";